import { categories } from '@/mocks/categories';

const featuredCategories = categories.slice(0, 9);

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="mb-12 md:mb-16">
          <p className="font-label text-xs md:text-sm uppercase tracking-[0.2em] text-accent-500 mb-3">
            Quick Access
          </p>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.15]">
            Shop by
            <br />
            Category
          </h2>
        </div>

        {/* Category Grid with Images */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-xl overflow-hidden hover:translate-y-[-4px] transition-all duration-300 cursor-pointer border border-transparent hover:border-primary-200/60"
            >
              {/* Category Image */}
              <div className="relative w-full h-44 md:h-52 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} collection`}
                  title={`Superbuy Spreadsheet - ${cat.name} Category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-4">
                  <div className="w-9 h-9 rounded-lg bg-background-50/90 backdrop-blur-sm flex items-center justify-center text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`${cat.icon} text-base`}></i>
                  </div>
                </div>
              </div>

              {/* Card Content */}
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2 group-hover:text-primary-700 transition-colors duration-200">
                  {cat.name}
                </h3>
                <p className="font-body text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-2 text-primary-600 font-label text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span>Browse Collection</span>
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* View All Categories Link */}
        <div className="mt-10 text-center">
          <div className="inline-flex flex-wrap justify-center gap-3">
            {categories.slice(9).map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-5 py-2.5 bg-background-50 text-foreground-700 font-label text-sm rounded-full border border-background-300/60 hover:border-primary-400 hover:text-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}